module.exports = __webpack_public_path__ + "static/media/responsibleDaughter2007.2048ba37.jpg";